import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
const steps = ['Open the modules.', 'Look through the visual activities.', 'Try the ready-to-teach classes.', 'Explore the circuits, progressions and programming resources.'];
export function Guarantee() {
  return <section className="bg-ivory-deep px-4 sm:px-6 py-9 sm:py-12" data-id="element-78" data-mp="1x4bq4sg0eh8o">
      <div className="max-w-2xl mx-auto bg-white border-2 border-gold/50 rounded-xl p-5 sm:p-8 text-center shadow-sm" data-id="element-79" data-mp="1x54op64te0fq">
        <div className="w-11 h-11 mx-auto rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center mb-3" data-id="element-80" data-mp="19ceeb1ck7p7k">
          <ShieldCheckIcon className="w-5 h-5 text-gold" data-id="element-81" data-mp="1j52em62r0bb1" />
        </div>

        <h2 className="font-heading font-extrabold uppercase text-base sm:text-xl leading-tight tracking-tight text-petrol mb-3" data-id="element-82" data-mp="1edu2h2a1abu6">
          7-Day Money-Back Guarantee
        </h2>

        <p className="text-[13px] sm:text-base font-semibold text-petrol/85 mb-3" data-id="element-83" data-mp="qm6iz5f3q31x">
          Explore the complete system.
        </p>

        <ul className="max-w-xs sm:max-w-sm mx-auto mb-4" data-id="element-84" data-mp="ozrsoo32f265">
          {steps.map(step => <li key={step} className="text-[12px] sm:text-sm text-petrol/70 leading-snug border-b border-petrol/10 py-1.5 last:border-b-0" data-id="element-85" data-mp="tycsimeenju2">
              {step}
            </li>)}
        </ul>

        <p className="text-[12px] sm:text-sm text-petrol/70 leading-relaxed max-w-lg mx-auto mb-3" data-id="element-86" data-mp="12pmvf4bbgsbf">
          You have 7 full days to decide whether Fitness Senior Ready™ belongs
          in your coaching workflow. If it isn't right for you, request a refund
          within the guarantee period.
        </p>

        <p className="font-heading font-extrabold uppercase text-[11px] sm:text-sm tracking-[0.12em] text-petrol pt-3 border-t border-gold/30" data-id="element-87" data-mp="f00t47zndwz7">
          Your purchase is protected.
        </p>
      </div>
    </section>;
}